import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../config/firebase';

export const createAdminUser = async () => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth, 
      'admin@avis.com', 
      'admin123'
    );
    console.log('Admin user created successfully:', userCredential.user.email);
    return userCredential.user;
  } catch (error: any) {
    if (error.code === 'auth/email-already-in-use') {
      console.log('Admin user already exists');
      return null;
    } else {
      console.error('Error creating admin user:', error);
      throw error;
    }
  }
};
